export default {
  // Colors taken from zuluhood logo: Z-colors :D
  zDarkBlue: '#193372',
  zBlue: '#3863C5',
  zLightBlue: '#7AD0E1',
  zOrange: '#FB7E48',
  zRed: '#DB5239',
  zBlack: '#002B49',
}
